var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8086 9.49163V14.4833C17.8086 16.7833 15.9419 18.65 13.6419 18.65H6.35856C4.05856 18.65 2.19189 16.7833 2.19189 14.4833V9.54997C2.82523 10.2333 3.72523 10.625 4.70023 10.625C5.75023 10.625 6.75856 10.1 7.39189 9.2583C7.95856 10.1 8.92523 10.625 10.0002 10.625C11.0669 10.625 12.0169 10.125 12.5919 9.29163C13.2336 10.1166 14.2252 10.625 15.2586 10.625C16.2669 10.625 17.1836 10.2166 17.8086 9.49163Z",
    fill: "#AECBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4916 1.04163H7.49162L6.87496 7.17496C6.82496 7.74163 6.90829 8.27496 7.11662 8.75829C7.59996 9.89163 8.73329 10.625 9.99996 10.625C11.2833 10.625 12.3916 9.90829 12.8916 8.76663C13.0416 8.40829 13.1333 7.99163 13.1416 7.56663V7.40829L12.4916 1.04163Z",
    fill: "#3C81FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6333 6.89163L18.3916 4.58329C18.0416 2.06663 16.9 1.04163 14.4583 1.04163H11.2583L11.875 7.29163C11.8833 7.37496 11.8916 7.46663 11.8916 7.62496C11.9416 8.05829 12.075 8.45829 12.275 8.81663C12.875 9.91663 14.0416 10.625 15.2583 10.625C16.3666 10.625 17.3666 10.1333 17.9916 9.26663C18.4916 8.59996 18.7166 7.75829 18.6333 6.89163Z",
    fill: "#649BFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49186 1.04163C3.04186 1.04163 1.90853 2.06663 1.5502 4.60829L1.3252 6.89996C1.24186 7.79163 1.48353 8.65829 2.00853 9.33329C2.64186 10.1583 3.61686 10.625 4.7002 10.625C5.91686 10.625 7.08353 9.91663 7.6752 8.83329C7.89186 8.45829 8.03353 8.02496 8.0752 7.57496L8.7252 1.04996H5.49186V1.04163Z",
    fill: "#649BFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45843 13.8834C8.4001 13.9917 7.6001 14.8917 7.6001 15.9584V18.65H12.3918V16.25C12.4001 14.5084 11.3751 13.6834 9.45843 13.8834Z",
    fill: "#3C81FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSelected);
export default __webpack_public_path__ + "static/media/shop-selected.10bfe6b0d5f9165f7010079ffeeb5d85.svg";
export { ForwardRef as ReactComponent };